import Link from "next/link";
import styles from "../../styles/BreadCrumbs.module.css";
import {Categories }from "../list/PageList";



export default function BreadCrumbs(props) {
   
  function catcheck(value) {
    var myCom;
    //console.log(value);
    if (value!= null) {
      myCom =<li><Link href={props.catlink} passHref>{props.cat}</Link></li>
      
    }

    return myCom;
  }

  return (
<div className={styles.container}>
<div className={styles.contant}>
<ol className={`${styles.breadcrumb }`}>
<li><Link href="/" passHref>Playcutegames</Link></li>

{!props.coloring== "coloring"&&<><li><Link href="/all-categories" passHref>Categories</Link></li></>}
{props.coloring == "coloring"&&<><li><Link href="/coloring-page" passHref>Coloring Page</Link></li></>}

{catcheck(props.catlink)}
<li className={styles.current}>{props.gamename}</li>
</ol>
</div>
</div>
  );
}
